"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export const useSetSearchParams = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Function to set search parameters
  const setSearchParams = useCallback(
    (queryName: string, selectedValue: string) => {
      const current = new URLSearchParams(Array.from(searchParams.entries()));

      const value = selectedValue.trim();
      if (queryName !== "page") {
        current.delete("page");
      }
      if (
        !value ||
        (queryName == "page" && Number(selectedValue) < 2) ||
        (queryName == "method" && value == "EVM") ||
        (queryName == "tab" && value == "blocks")
      ) {
        current.delete(queryName);
      } else {
        current.set(queryName, selectedValue);
      }

      const search = current.toString();
      const query = search ? `?${search}` : "";

      // Update the URL with the new search params
      return `${pathname}${query}`;
    },
    [router, pathname, searchParams],
  );

  // Function to prefetch a route with current search parameters
  const prefetchRoute = useCallback(
    (queryName: string, selectedValue: string) => {
      const current = new URLSearchParams(Array.from(searchParams.entries()));

      const value = selectedValue.trim();
      if (!value) {
        current.delete(queryName);
      } else {
        current.set(queryName, selectedValue);
      }
      const search = current.toString();
      const query = search ? `?${search}` : "";
      // Prefetch the route with the current search parameters
      router.prefetch(`${pathname}${query}`);
    },
    [router, pathname, searchParams],
  );

  return { setSearchParams, prefetchRoute };
};
